module.exports = __webpack_public_path__ + "img/Mycoupon.58a8c12c.png";